import React from 'react';

import Button from './Button';

const PrimaryButton = ({ children, type, className, onClick, isDisabled }) => (
  <Button type={type} isPrimary={true} onClick={onClick} className={className} isDisabled={isDisabled}>{children}</Button>
);

export default PrimaryButton;